import { render, staticRenderFns } from "./server_errors.vue?vue&type=template&id=947acbc0&"
import script from "./server_errors.vue?vue&type=script&lang=js&"
export * from "./server_errors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports